<template>
  <v-card class="left-vertical-card">
    <div class="d-flex bg-titre">
      <div class="secondary--text align-self-center pl-3 titre-h3 mr-auto">
        Engrais (unités)
      </div>

      <v-btn
        class="align-self-center"
        text
        @click="onClose()"
      >
        <v-icon color="secondary">
          mdi-close
        </v-icon>
      </v-btn>
    </div>
    <div
      v-for="uneEngrais in engraisModifiable"
      :key="uneEngrais.comparateurMargeParametre.typeRubrique.id"
      class="d-flex flex-column mt-6 mx-4"
      @click="openModalAbonnement()"
    >
      <AgrialSelect
        v-if="uneEngrais.comparateurMargeParametre.typeRubrique.isValeurEconomiqueUniquement"
        v-model="uneEngrais.valeurSaisie"
        :items="valeurEcos"
        :label="uneEngrais.comparateurMargeParametre.typeRubrique.libelleSousRubrique"
        hide-details
        :class="($roles.hasParamCulturialWriteAccess() || $roles.hasPersoWriteAccess()) ? 'cursor-pointer' : 'cursor-no-drop'"
        :readonly="!isCulturialAbonne || !hasDroitEcriture"
      >
        <template
          v-if="!isCulturialAbonne"
          v-slot:prepend-inner
        >
          <v-icon
            class="prepend-icon"
            :style="($roles.hasParamCulturialWriteAccess() || $roles.hasPersoWriteAccess()) ? 'cursor: pointer;' : 'cursor: no-drop;'"
            size="18"
            color="var(--gris-clair)"
          >
            mdi-lock
          </v-icon>
        </template>
      </AgrialSelect>
      <AgrialInputNumber
        v-else
        v-model="uneEngrais.valeurSaisie"
        :label="uneEngrais.comparateurMargeParametre.typeRubrique.libelleSousRubrique"
        :readonly="!isCulturialAbonne || !hasDroitEcriture || hasSameValue(uneEngrais)"
        hide-details
        :class="($roles.hasParamCulturialWriteAccess() || $roles.hasPersoWriteAccess()) ? 'cursor-pointer' : 'cursor-no-drop'"
        @input="checkValue(uneEngrais)"
      >
        <template
          v-if="!isCulturialAbonne"
          v-slot:prepend-inner
        >
          <v-icon
            class="prepend-icon"
            :style="($roles.hasParamCulturialWriteAccess() || $roles.hasPersoWriteAccess()) ? 'cursor: pointer;' : 'cursor: no-drop;'"
            size="18"
            color="var(--gris-clair)"
          >
            mdi-lock
          </v-icon>
        </template>
      </AgrialInputNumber>
      <span
        v-if="erreur && engraisSelected && uneEngrais.comparateurMargeParametre.id === engraisSelected.comparateurMargeParametre.id"
        class="red--text action"
      >{{ erreur }}</span>
    </div>
    <div class="d-flex mx-4 mt-4 justify-space-between">
      <AgrButton
        outlined
        @click="onClose()"
      >
        Annuler
      </AgrButton>
      <AgrButton
        :disabled="!(erreur == null && !loading) || !isCulturialAbonne || !hasDroitEcriture"
        :loading="loading"
        @click="saveParametre()"
      >
        Valider
      </AgrButton>
    </div>
  </v-card>
</template>
<script>
import { AgrButton } from '@agrial/ui'
import AgrialInputNumber from '@/components/form/agrial-input-number.vue'
import AgrialSelect from '@/components/form/agrial-select.vue'
import { mapGetters } from 'vuex'
import {clone} from '@/utils/clone'

export default {
  name: 'UpdateEngraisModal',
  components: {AgrButton,  AgrialInputNumber, AgrialSelect},
  props: {
    engrais: {
      type: Array,
      default: () => []
    },
    isCulturialAbonne: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    hasDroitEcriture: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      engraisModifiable: null,
      erreur: null,
      engraisSelected: null,
      valeurEcos: ['Oui', 'Non'],
    }
  },

  computed: {
    ...mapGetters({
      unites: 'comparateurMarge/unites'
    }),

  },

  created () {
    this.engraisModifiable = clone(this.engrais)
    this.engraisModifiable = this.engraisModifiable.filter(e => e.valeurSaisie != null)
    this.engraisModifiable.filter(e => e.comparateurMargeParametre.typeRubrique.isValeurEconomiqueUniquement).map(e => {
      e.valeurSaisie = e.valeurSaisie > 0 ? 'Oui' : 'Non'
    })
  },

  methods: {
    onClose () {
      this.$emit('close')
    },
    checkValue (engraisSelected) {
      this.engraisSelected = engraisSelected
      this.erreur = null
      if (engraisSelected && engraisSelected.valeurSaisie > engraisSelected.comparateurMargeParametre.valeurAdmin.maximum) {
        this.erreur = 'Doit être <= ' + engraisSelected.comparateurMargeParametre.valeurAdmin.maximum
      }
      else if (engraisSelected && engraisSelected.valeurSaisie < engraisSelected.comparateurMargeParametre.valeurAdmin.minimum) {
        this.erreur = 'Doit être >= ' + engraisSelected.comparateurMargeParametre.valeurAdmin.minimum
      }
    },
    saveParametre () {
      this.engraisModifiable.forEach(element => {
        if (element.comparateurMargeParametre.typeRubrique.isValeurEconomiqueUniquement) {
          element.valeurSaisie = element.valeurSaisie === 'Oui' ? element.comparateurMargeParametre.valeurEconomique : 0
        }
      })
      this.$emit('updateParametre', this.engraisModifiable)
    },
    openModalAbonnement () {
      if (!this.isCulturialAbonne) {
        this.$emit('openModalAbonnement')
      }
    },
    hasSameValue (engrais) {
      return engrais.comparateurMargeParametre.valeurDefaut === engrais.comparateurMargeParametre.valeurAdmin.minimum && engrais.comparateurMargeParametre.valeurDefaut === engrais.comparateurMargeParametre.valeurAdmin.maximum
    }
  }
}
</script>
<style lang="scss" scoped>
.left-vertical-card {
  border-radius: 0 !important;
}

.bg-titre {
  height: 70px;
  background-color: #f1f2f5;
}
.prepend-icon {
  z-index: 100;
}
.cursor-pointer {
  ::v-deep.v-input--is-readonly input {
    cursor:pointer;
  }
}
.cursor-no-drop {
  ::v-deep.v-input--is-readonly input {
    cursor:no-drop;
  }
}
</style>